import React from 'react'
import Hero from '../Components/Hero/Hero'
//import Popular from '../Components/Popular/Popular'
import Offer from '../Components/Offers/Offer'
// import NewCollections from '../Components/NewCollections/NewCollections'
import NewsLetter from '../Components/NewsLetter/NewsLetter'
import Facility from '../Components/Facility/Facility'
import Category from '../Components/Category/Category'

const Shop = () => {
  return (
    <div>
    <Hero />
   
    <Category />
   {/* <Popular /> */}
    <Offer /> 
    {/* <NewCollections /> */}
    <NewsLetter />
     <Facility/>
    </div>
  )
}

export default Shop